import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import {
  RenderInput,
  RenderSelect,
  RenderRadio,
} from "../../Common/InputComponents/Inputs.jsx";
import {
  required,
  requiredTarget,
  requiredSeq,
  maxLength17,
  minLength5,
  hasValidWhitespace,
  configureNhejContextSequenceValidator,
  nullValidationForServerErrors,
} from "../../../util/validations.js";
import { firstSeventeen, removeSpaces } from "../../../util/format";
import {
  tooltipReferenceGenomeOption,
  tooltipReferenceGenomeMatchReference,
  tooltipGenomeEditDetectionHdrContextSequence,
  tooltipGenomeEditDetectionHdrDonorSequence,
  tooltipGenomeEditDetectionSpecies,
  tooltipGenomeEditDetectionNhejContextSequence,
  tooltipGenomeEditDetectionNhejDonorPresent,
} from "../../Common/Misc/Tooltips.jsx";
import _ from "underscore";
const genomeOptions = [
  "Homo sapiens",
  "Mus musculus",
  "Rattus norvegicus",
  "Other",
];

const sequenceVariation = (species) => {
  return (
    <span>
      The sequence being edited <strong>is a variation</strong> of the {species}{" "}
      reference genome
    </span>
  );
};

const sequenceMatches = (species) => {
  return (
    <span>
      The sequence being edited <strong>matches</strong> the {species} reference
      genome
    </span>
  );
};

export const GenomeEditDetectionNhej = ({ fields, custom }) => {
  const validatedAssayDetails = (custom && custom.validatedAssayDetails) || {};

  //const selectedSpecies = custom.formObj && custom.formObj.values && custom.formObj.values.species;

  return (
    <div>
      {fields.map((genomeEditDetectionNhej, index) => {
        const validationErrorDetails = validatedAssayDetails[index] || {};
        const contextSequenceRegEx = /contextsequence/i;
        const donorSequenceRegEx = /donorsequence/i;
        const contextSequenceErrors =
          (nullValidationForServerErrors(
            validationErrorDetails,
            "GenomeEditDetection",
            "NhejGenomeEdit"
          ) &&
            validationErrorDetails.Errors[0].Property &&
            contextSequenceRegEx.test(
              validationErrorDetails.Errors[0].Property
            ) &&
            validationErrorDetails) ||
          {};
        const donorSequenceErrors =
          (nullValidationForServerErrors(
            validationErrorDetails,
            "GenomeEditDetection",
            "NhejGenomeEdit"
          ) &&
            validationErrorDetails.Errors[0].Property &&
            donorSequenceRegEx.test(
              validationErrorDetails.Errors[0].Property
            ) &&
            validationErrorDetails) ||
          {};

        const selectedSpecies =
          custom.formObj &&
          custom.formObj.values &&
          custom.formObj.values.genomeEditDetectionNhej &&
          custom.formObj.values.genomeEditDetectionNhej[index].species;

        const sequenceVariationType =
          custom.formObj &&
          custom.formObj.values &&
          custom.formObj.values.genomeEditDetectionNhej &&
          custom.formObj.values.genomeEditDetectionNhej[index]
            .sequenceVariationType;
        const donorPresent =
          custom.formObj &&
          custom.formObj.values &&
          custom.formObj.values.genomeEditDetectionNhej &&
          custom.formObj.values.genomeEditDetectionNhej[index].donorPresent;

        const sequenceVariationVisibility =
          selectedSpecies && selectedSpecies !== "Other";

        const isSelectedSpeciesOther = selectedSpecies === "Other";

        const contextSequenceVisibility =
          sequenceVariationType !== undefined || selectedSpecies === "Other";

        const donorPresenceVisibility =
          sequenceVariationType !== undefined || selectedSpecies === "Other";

        const donorSequenceVisibility =
          donorPresenceVisibility && donorPresent && donorPresent === "true";

        const contextSequenceRelationVisibility =
          sequenceVariationType && sequenceVariationType === "false";

        const isMatchSelected =
          sequenceVariationType && sequenceVariationType === "true";

        const tooltipContextSequence = tooltipGenomeEditDetectionNhejContextSequence(
          isMatchSelected,
          isSelectedSpeciesOther
        );

        const clearValidationMessageOnChange = () => {
          custom.actions.clearValidationMessages(index);
        };
        return (
          <div key={index} className="inputs">
            {/* Assay Target Name for the  Nhej input*/}
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <Field
                    name={`${genomeEditDetectionNhej}.assayTargetName`}
                    placeholder="17 chars. maximum"
                    className="form-control"
                    type="text"
                    component={RenderInput}
                    label="Identifier:"
                    validate={[requiredTarget, hasValidWhitespace, minLength5]}
                    normalize={firstSeventeen}
                  />
                </div>
              </div>
              <div className="col" />
            </div>

            {/* Species for the  Nhej input*/}
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <Field
                    name={`${genomeEditDetectionNhej}.species`}
                    className="form-control"
                    component={RenderSelect}
                    label="Species:"
                    tooltip={tooltipGenomeEditDetectionSpecies}
                    validate={[]}
                  >
                    {genomeOptions &&
                      genomeOptions.map((option) => {
                        return (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        );
                      })}
                  </Field>
                </div>
              </div>
              <div className="col" />
            </div>

            {/*sequenceVariationType for the edit sequence*/}
            {sequenceVariationVisibility && (
              <div className="row">
                <div className="col">
                  <div id="sequenceVariationTypeContainer">
                    <Field
                      name={`${genomeEditDetectionNhej}.sequenceVariationType`}
                      label="Choose an option:"
                      component={RenderRadio}
                      tooltip={tooltipReferenceGenomeMatchReference}
                      options={{
                        true: sequenceMatches(selectedSpecies),
                        false: sequenceVariation(selectedSpecies),
                      }}
                    />
                  </div>
                </div>
                <div className="col" />
              </div>
            )}

            {/* context sequence for the edit sequence*/}
            {contextSequenceVisibility && (
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <Field
                      name={`${genomeEditDetectionNhej}.contextSequence`}
                      className="form-control"
                      type="textArea"
                      rows="8"
                      placeholder="Eg: …AGATGCTAT^GCTTATCTA…"
                      component={RenderInput}
                      label="Context Sequence with Cut Site:"
                      tooltip={tooltipContextSequence}
                      normalize={removeSpaces}
                      validate={[requiredSeq]}
                      serverValidation={contextSequenceErrors}
                      onChange={clearValidationMessageOnChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* contextSequenceRelation option for the edit sequence*/}
            {contextSequenceRelationVisibility && (
              <div className="row">
                <div className="col">
                  <Field
                    name={`${genomeEditDetectionNhej}.contextSequenceRelation`}
                    label="This Context Sequence:"
                    component={RenderRadio}
                    validate={[required]}
                    tooltip={tooltipReferenceGenomeOption}
                    options={{
                      HomologousVariant:
                        "Replaces the homologous sequence in the background genome",
                      Insertion: "Is an insertion into the background genome",
                    }}
                  />
                </div>
                <div className="col" />
              </div>
            )}
            <br />

            {/* donor Present option for the edit sequence*/}
            {donorPresenceVisibility && (
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <Field
                      name={`${genomeEditDetectionNhej}.donorPresent`}
                      label="Is there a donor present in the reaction?"
                      component={RenderRadio}
                      tooltip={tooltipGenomeEditDetectionNhejDonorPresent}
                      options={{
                        true: "Yes",
                        false: "No",
                      }}
                    />
                  </div>
                </div>
                <div className="col" />
              </div>
            )}

            {/* donor sequence option for the edit sequence*/}
            {donorSequenceVisibility && (
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <Field
                      name={`${genomeEditDetectionNhej}.donorSequence`}
                      className="form-control"
                      type="textArea"
                      rows="8"
                      placeholder="Enter Donor Sequence here."
                      component={RenderInput}
                      label="Donor Sequence:"
                      validate={[requiredSeq]}
                      tooltip={tooltipGenomeEditDetectionHdrDonorSequence}
                      normalize={removeSpaces}
                      serverValidation={donorSequenceErrors}
                      onChange={clearValidationMessageOnChange}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

GenomeEditDetectionNhej.propTypes = {
  fields: PropTypes.object.isRequired,
};
